module.exports = __webpack_public_path__ + "img/lineup.89b9cdd0.png";